import React from "react";

/**
 * TextAnswer - Renders plain text answer from AI
 * @param {Object} props
 * @param {string} props.text - The text content to display
 * @returns {JSX.Element}
 */
const TextAnswer = ({ text }) => {
    if (!text || typeof text !== "string") return null;

    return (
        <p className="text-fluid-base whitespace-pre-wrap break-words text-gray-900">
            {text}
        </p>
    );
};

export default TextAnswer;
